import { c as r } from "./ghl-ui.es669.js";
import o from "./ghl-ui.es1193.js";
const {
  cubicBezierEaseIn: a,
  cubicBezierEaseOut: s
} = o;
function m({
  duration: n = "0.3s",
  leaveDuration: i = "0.2s",
  name: t = "slide-in-from-right"
} = {}) {
  return [r(`&.${t}-transition-leave-active`, {
    transition: `transform ${i} ${a}`
  }), r(`&.${t}-transition-enter-active`, {
    transition: `transform ${n} ${s}`
  }), r(`&.${t}-transition-enter-to`, {
    transform: "translateX(0)"
  }), r(`&.${t}-transition-enter-from`, {
    transform: "translateX(100%)"
  }), r(`&.${t}-transition-leave-from`, {
    transform: "translateX(0)"
  }), r(`&.${t}-transition-leave-to`, {
    transform: "translateX(100%)"
  })];
}
export {
  m as slideInFromRightTransition
};
